/*
 * Svea's part payment calculator (snippets/payment-options.liquid) follows the variant picker:
 * product-page.js announces the new price (`product:variant-change`), and Svea gets its own update
 * event. Svea's script itself loads and renders the calculator as its embed documents.
 */

document.addEventListener('product:variant-change', (event) => {
  const cents = Number(event.detail?.price);
  if (!Number.isFinite(cents)) return;
  const euros = (cents / 100).toFixed(2);

  for (const widget of document.querySelectorAll('.svea-pp-widget-part-payment')) {
    widget.setAttribute('data-price', euros);
  }
  document.dispatchEvent(new CustomEvent('svea-partpayment-calculator-update-price', { detail: { price: euros } }));
});
